import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useBookingContext } from '@providers/booking'
import { useSessionContext } from '@providers/session'
import { MAX_WIDGET_SIZE } from '@shared/constants'
import { i18WithDefault as t } from '@shared/locale'
import { Spacer, Spacer2 } from 'components-ui'
import { useBookingReservation } from 'hooks/use_booking_reservation'
import { useRedirectNoData } from 'hooks/use_redirect_no_data'
import { Hooks } from 'service-api'
import { DetailsPoliciesForm } from './details_policies_form'
import { PanelSkeleton } from './panel_skeleton'

export const DetailsPolicies = () => {
  const { accountName = '' } = useParams()
  const bookingCtx = useBookingContext()
  const sessionCtx = useSessionContext()
  const theme = useTheme()
  const renderStyle = useMediaQuery(theme.breakpoints.down('md')) ? 'mobile' : 'desktop'
  const isMobile = renderStyle === 'mobile'

  useEffect(() => {
    bookingCtx.dispatch({
      type: 'SET_SEARCH_STATE',
      payload: { value: 'detailsPolicies', formHandler: 'details-policies-form' },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookingCtx.state.currentState])

  const reservation = useBookingReservation(accountName)
  const userProfile = Hooks.useClientUser(accountName, sessionCtx.state.user?.userId || '')

  useRedirectNoData()

  const renderSkeleton = () => {
    return (
      <>
        <Stack direction="column" spacing={2} flex={1} width="100%">
          <PanelSkeleton />
          <PanelSkeleton />
          <PanelSkeleton />
          <PanelSkeleton />
          <PanelSkeleton />
        </Stack>
        <Stack direction="column" spacing={2} flex={1} mt={isMobile ? 2 : 0} width="100%">
          <PanelSkeleton />
          <PanelSkeleton />
        </Stack>
      </>
    )
  }

  return (
    <Box sx={{ maxWidth: MAX_WIDGET_SIZE, margin: '0 auto' }}>
      <Spacer height={3} />
      <Typography variant="h1" sx={{ px: 2 }}>
        {t('detailsPolicies.title')}
      </Typography>
      <Spacer2 />
      <Stack direction={{ sx: 'column', md: 'row' }} alignItems="start" spacing={2} flex={1}>
        {reservation.isLoading || userProfile.isLoading ? (
          renderSkeleton()
        ) : reservation.isSuccess ? (
          <DetailsPoliciesForm reservation={reservation.data!} userProfile={userProfile.data!} />
        ) : null}
      </Stack>
    </Box>
  )
}
